import styled from 'styled-components'

import TextInput from '../basic-components/TextInput'

const Label = styled.label`
  flex: none;
  display: inline-block;
  text-align: right;
  padding: 0.7rem;
`
const RowContainer = styled.div`
  display: flex;
  flex: none;
  flex-direction: row;
  justify-content: space-evenly;
`

export default function ByOwnerNameDialog({ownerName, onOwnerNameChange}) {

  const changeHandler = (e) => {
    onOwnerNameChange(e.target.value);
  }

  return (
    <RowContainer>
     <Label>Street Name:</Label>
     <TextInput
        value={ownerName}
        onChange={changeHandler}
        placeholder={"lastname, firstname"}
        autoFocus={true}
      />
    </RowContainer>
  );
}
